var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9695 17.001L27.1955 13.0885L20.2605 20.0235L27.195 26.958L33.9925 23.0325C35.0525 22.3885 35.685 21.2635 35.685 20.0235C35.685 18.7835 35.052 17.6585 33.9695 17.001Z",
    fill: "#FFCE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2604 20.0235L1.37094 0.998016C1.03619 1.32964 0.770506 1.72435 0.589249 2.15929C0.407992 2.59424 0.314759 3.06081 0.314942 3.53202V36.457C0.314942 37.4425 0.713942 38.334 1.37094 38.9915L20.2604 20.0235Z",
    fill: "url(#paint0_linear_81_502)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2603 20.0235L27.1953 13.0885L27.2063 13.0775L17.9143 7.72751L5.66535 0.528508C4.56235 -0.151992 3.22485 -0.175492 2.09835 0.458008C1.84035 0.622008 1.60535 0.786508 1.37085 0.997508L20.2603 20.0235Z",
    fill: "#00F076"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.37085 38.991C1.60535 39.202 1.84035 39.3665 2.09835 39.5305C2.66135 39.8355 3.24835 40 3.83485 40C4.46835 40 5.07835 39.8125 5.64185 39.484L17.9139 32.3195L27.2059 26.9695L27.1949 26.9585L20.2604 20.0235L1.37085 38.991Z",
    fill: "#F63448"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_81_502",
    x1: -8.12706,
    y1: 29.493,
    x2: 10.8694,
    y2: 10.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C5FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.6f309ababdc8224d4dffd47b20475e40.svg";
export { ForwardRef as ReactComponent };